"use client"

import { ComponentConfig } from "@measured/puck"
// import "swiper/css"
// import "swiper/css/navigation"
// import "swiper/css/pagination"
import Image from "next/image"
import Link from "next/link"
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { twMerge } from "tailwind-merge"
import { toImageSrc } from "../../../../../../lib/utils"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../lib/helper"
import "./css/custom-bullet.css"

export interface SimpleSliderProps extends CommonStylesProps {
  slides: { id?: number; image?: string; url: string; title?: string; date?: string }[]
  spaceBetween?: number
  slidesPerView?: number
  loop?: boolean
  speed?: number
  timeDelay?: number
  pagination?: "default" | "custom"
}

export const RenderConfig: ComponentConfig<SimpleSliderProps> = {
  // @TODO: missing responsive CSS @datvct

  render: ({
    slides,
    spaceBetween,
    slidesPerView,
    loop,
    speed,
    timeDelay,
    pagination,
    styles,
    responsiveType,
    className,
  }) => {
    // const paginationCustom = {
    //   clickable: true,
    //   bulletClass:
    //     pagination === "default" ? "custom-swiper-pagination-bullet" : "custom-swiper-pagination-section-bullet",
    //   bulletActiveClass:
    //     pagination === "default"
    //       ? "custom-swiper-pagination-bullet-active"
    //       : "custom-swiper-pagination-section-bullet-active",
    //   renderBullet: function (index: number, className: string) {
    //     return `<span class="${className}">${""}</span>`
    //   },
    // }

    const id = `simple-slider-${Math.random().toString(36).substr(2, 9)}`

    // Merge default styles with user-defined styles
    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    // Generate responsive CSS
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <Swiper
          spaceBetween={spaceBetween}
          slidesPerView={slidesPerView}
          modules={[Pagination, Autoplay, Navigation]}
          loop={loop}
          speed={speed}
          autoplay={{ delay: timeDelay }}
          // navigation={true}
          className={`${id} ${twMerge(className)}`}
        >
          {slides.map(({ id, image, url, title, date }, index) => (
            <SwiperSlide key={index}>
              <div className="text-center">
                <Link
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative w-full h-full block overflow-hidden"
                >
                  <div className="w-full h-full transition-transform duration-300 ease-in-out transform">
                    <div className="relative w-full h-full">
                      <Image
                        src={toImageSrc(image)}
                        alt={`Slide ${index}`}
                        fill
                        unoptimized={!!image && /^https?:\/\//i.test(image)}
                        className="object-cover"
                      />
                    </div>
                  </div>
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </>
    )
  },
}
